import AppCheckBox from "@/features/line-sheet-sets/app-checkbox";
import { ICellRendererParams } from "ag-grid-community";
import { FlatProduct } from "@/features/line-sheet-sets/helpers/sheet-state";
import { Flex } from "@chakra-ui/react";
import { is } from "immer/src/internal";

interface ProductCheckboxCellProps extends ICellRendererParams<FlatProduct> {}
export default function ProductCheckboxCell({
  node,
  api,
  rowIndex,
}: ProductCheckboxCellProps) {
  if (rowIndex % 3 === 0) {
    // 만약 cost/retail이 없고 supply price만 있다면 컨디션 조작 불가능. 최종 공급가가 확정된 경우이기 때문.
    let isDisabled = node.selectable === false || node.data?.selectable === false;
    if (
      !isDisabled &&
      rowIndex !== null &&
      node.parent?.childrenAfterFilter?.[rowIndex]?.data?.priceAmount && // supply price
      !node.parent?.childrenAfterFilter?.[rowIndex + 1]?.data?.priceAmount && // cost
      !node.parent?.childrenAfterFilter?.[rowIndex + 2]?.data?.priceAmount // retail
    ) {
      node.selectable = false;
      isDisabled = true;
    }
    return (
      <Flex
        backgroundColor={"transparent"}
        height={"100%"}
        justifyContent={"center"}
      >
        <AppCheckBox
          size={"small"}
          isChecked={node.isSelected()}
          isIndeterminate={node.data?.indeterminate}
          onChange={(checked) => {
            node.setSelected(checked);
            const prevNode = api.getDisplayedRowAtIndex(rowIndex + 1)!!;
            const nextNode = api.getDisplayedRowAtIndex(rowIndex + 2)!!;
            prevNode.setSelected(checked);
            nextNode.setSelected(checked);
            api.refreshCells({
              force: true,
              rowNodes: [node, prevNode, nextNode],
              columns: ["isChecked"],
            });
          }}
          isDisabled={isDisabled}
        />
      </Flex>
    );
  } else {
    return null;
  }
}
